import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {Dossiers, ListReference, PopulationEnum} from '../index';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {EtptsMsModel} from '../../../dossier/common/form-ms-sbtcp/etpts-ms.model';
import {CoutEtptModel} from './cout-etpt.model';


@Injectable({ providedIn: 'root' })
export class CoutsEtptService extends DaoGeneric<ListReference> {
  private url = `${environment.baseUrl}/dar/dossiers/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  calculCoutsPostes() {
    const url = `${this.url}calcul_couts_total/`;
    return this.httpClient.get(url);
  }

  calculCoutsCommissionByYears() {
    const url = `${this.url}calcul_commission_couts_biatoss_enseignants/`;
    return this.httpClient.get(url);
  }

  calculEtptComissionByYears() {
    const url = `${this.url}calcul_commission_etpt_biatoss_enseignants/`;
    return this.httpClient.get(url);
  }

  calculCommissionCumulEtpt() {
    const url = `${this.url}calcul_commission_cumul_etpt_biatoss_enseignants/`;
    return this.httpClient.get(url);
  }

  calculCommissionCumulCouts() {
    const url = `${this.url}calcul_commission_cumul_couts_biatoss_enseignants/`;
    return this.httpClient.get(url);
  }

  /**
   * Calcul des ETPT d'un dossier répartis par années
   * @param {Dossiers} dossier
   */
  calculEtptDossier(dossier: Dossiers): Observable<EtptsMsModel> {
    const url = `${this.url}${dossier.uuid}/calcul_etpt_dossier/`;
    return this.httpClient.get<EtptsMsModel>(url);
  }
  /**
   * Test de _data et si contenu
   * @param _data
   * @private
   */
  private _ifDataThenElse(_data) {
    if (_data && _data.length > 0) {
      return _data;
    }
    return [];
  }

  /**
   * Obtention des données ETPT / Coûts / an pour commission ou cumul
   * @param {string} type : etpt | couts | etptcumul | coutscumul
   * @param _data
   * @private
   */
  public getCoutEtpData(type: 'etpt' | 'etptcumul' | 'couts' | 'coutscumul' = 'etpt', _data): CoutEtptModel {
    if (_data) {
      const values = <CoutEtptModel> {};
      switch (type) {
        case 'etpt':
          values.value_biatoss = this._ifDataThenElse(_data[PopulationEnum.biatoss]);
          values.value_enseignants = this._ifDataThenElse(_data[PopulationEnum.enseignant]);
          break;
        case 'etptcumul':
          values.value_biatoss = this._ifDataThenElse(_data[PopulationEnum.biatoss]);
          values.value_enseignants = this._ifDataThenElse(_data[PopulationEnum.enseignant]);
          break;
        case 'couts':
          values.value_biatoss = this._ifDataThenElse(_data[PopulationEnum.biatoss]);
          values.value_enseignants = this._ifDataThenElse(_data[PopulationEnum.enseignant]);
          break;
        case 'coutscumul':
          values.value_biatoss = this._ifDataThenElse(_data[PopulationEnum.biatoss]);
          values.value_enseignants = this._ifDataThenElse(_data[PopulationEnum.enseignant]);
          break;
      }
      return values;
    }
  }
}
